import { INPUT_DATE_SELECT_FORMAT } from '../types/InputDateSelectTransformerTypes';

export const stringTwoDigitNumber = (number: number) => {
	return number <= 9 ? `0${String(number)}` : String(number);
};

export const generateOption = (value: number) => {
	return {
		value: value,
		label: stringTwoDigitNumber(value)
	};
};

export const getOptionsSuccession = (totalNumber: number, initialNumber = 0) => {
	return Array.from({ length: totalNumber }, (_, i) => ({
		value: i + 1 + initialNumber,
		label: stringTwoDigitNumber(i + 1 + initialNumber)
	}));
};

export const getOptionsYearsSuccession = (totalNumber: number, initialYear = new Date().getFullYear()) => {
	const years = Array.from({ length: totalNumber }, (_, i) => ({
		value: initialYear - i,
		label: String(initialYear - i)
	}));
	if (initialYear > new Date().getFullYear()) return years.reverse();
	return years;
};

/**
 * Default min date is 100 years ago if no credit card.
 */
export const getDefaultMinimumDate = (format: INPUT_DATE_SELECT_FORMAT) => {
	if (format === INPUT_DATE_SELECT_FORMAT.CREDIT_CARD || format === INPUT_DATE_SELECT_FORMAT.EXPIRATION_DATE)
		return new Date();
	const pastDate = new Date();
	pastDate.setFullYear(pastDate.getFullYear() - 100);
	return pastDate;
};

/**
 * Default maximum date is today. But 10 years from now if using credit card instead.
 */
export const getDefaultMaximumDate = (format: INPUT_DATE_SELECT_FORMAT) => {
	if (format !== INPUT_DATE_SELECT_FORMAT.CREDIT_CARD && format !== INPUT_DATE_SELECT_FORMAT.EXPIRATION_DATE)
		return new Date();
	const pastDate = new Date();
	pastDate.setFullYear(pastDate.getFullYear() + 10);
	return pastDate;
};
